export default __webpack_public_path__ + "static/media/violin.0df34a53.png";